import React from "react";
import StreamPlayer from "./components/StreamPlayer";

function App() {
  return (
    <div>
      <StreamPlayer />
    </div>
  );
}

export default App;
